import React from 'react';
import { useTranslation } from 'react-i18next';
import { EVENTS, trackEvent } from '@app/segment';
import { Box, Grid, GridItem, Text } from '@stockx/ui';
import { BrowseSwitcherLink, ProductSwitcherLink } from '@app/router';
import { MENU_ITEMS } from '@app/shell/SiteHeader/shared/consts/GenderNavigation';

const SubNavigation = ({ vertical }) => {
  const verticalMenuItems = MENU_ITEMS[vertical];
  const { t } = useTranslation();

  const handleVerticalClick = (label) => {
    trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
      label,
    });
  };

  if (!vertical || !verticalMenuItems) {
    return null;
  }

  return (
    <Box
      backgroundColor="neutral.white"
      paddingTop="3"
      paddingBottom="8"
      position="absolute"
      width="100%"
      top="100%"
      left="0"
      data-testid="SubNavigation"
      display="none"
      as="ul"
    >
      <Box maxWidth="6xl" paddingX="4" margin="0 auto">
        <Grid
          as="ul"
          justifyContent="center"
          templateColumns={`repeat(${verticalMenuItems?.submenu?.length}, minmax(auto, 200px))`}
          gap="20px"
          sx={{
            listStyle: 'none',
          }}
        >
          {verticalMenuItems?.submenu.map(({ title, submenu, link }) => (
            <GridItem as="li" textAlign="center" key={title}>
              <Box display="inline-block" textAlign="left">
                <Text
                  fontFamily="suisseIntlMedium"
                  fontWeight="500"
                  marginBottom="4"
                  whiteSpace="pre-line"
                >
                  {link ? (
                    <BrowseSwitcherLink
                      key="name"
                      to={link}
                      onClick={() => handleVerticalClick(link)}
                    >
                      {t(title)}
                    </BrowseSwitcherLink>
                  ) : (
                    t(title)
                  )}
                </Text>
                <Box
                  as="ul"
                  whiteSpace="pre-line"
                  sx={{
                    listStyle: 'none',
                  }}
                >
                  {submenu.map(({ title, urlKey, isProduct }) => (
                    <Text
                      as="li"
                      fontFamily="suisseIntlRegular"
                      marginBottom="2"
                      key={title}
                    >
                      {isProduct ? (
                        <ProductSwitcherLink
                          to={urlKey}
                          onClick={() => handleVerticalClick(title)}
                        >
                          {title}
                        </ProductSwitcherLink>
                      ) : (
                        <BrowseSwitcherLink
                          to={urlKey}
                          onClick={() => handleVerticalClick(title)}
                        >
                          {title}
                        </BrowseSwitcherLink>
                      )}
                    </Text>
                  ))}
                </Box>
              </Box>
            </GridItem>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SubNavigation;
